export function createNavItem(type, gotoPage) {
    return {
        type: type,
        key: gotoPage === undefined ? type : type + "_disabled",
        label: type === 'previous' ? '«' : '»',
        a11yLabel: type === 'previous' ? 'Previous' : 'Next',
        gotoPage: gotoPage,
    };
}
export function createPageItem(page, active) {
    return {
        type: 'page',
        key: active ? "page_" + page : "active_" + page,
        label: page.toString(),
        a11yLabel: active ? '(current)' : undefined,
        gotoPage: page,
        active: active,
    };
}
export function createEllipsisItem(position) {
    return {
        type: 'ellipsis',
        key: "ellipsis_" + position,
        label: '…',
        a11yHidden: true,
        gotoPage: undefined,
    };
}
